import React, { createContext, useContext, useState, useEffect } from "react";
import { connect } from "react-redux";

import { useNavigate } from 'react-router-dom';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as LoginActions from "./actions";

const AuthUserContext = createContext(null);
const AuthOperationContext = createContext({
  login: (_) => console.error("The provider has not been set up!"),
  logout: () => console.error("The provider has not been set up.")
})

const AuthUserProvider = ({
  dispatch,
  contracts,
  children
}) => {
  const navigate = useNavigate();

  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.TkgGoldBuyingAndSelling;
  const [ dataKey, setDataKey ] = useState(null);

  const [ userId, setUserId ] = useState(null);
  const [ authUser, setAuthUser ] = useState(null);

  useEffect(() => {
    if (dataKey === null)
      return;

    var pathname = null;

    var isValid = contracts.TkgGoldBuyingAndSelling.checkIdentification[dataKey]
      ? contracts.TkgGoldBuyingAndSelling.checkIdentification[dataKey].value
      : null;

    if (isValid === null) {
      return;
    } else if (isValid) {
      pathname="/welcome";
      dispatch(notifyLoginResult(isValid, userId));
      setDataKey(null);
      setAuthUser({ userId });
      navigate(pathname);
      isValid = null;
    } else {
      pathname="/login";
      dispatch(notifyLoginResult(isValid, null));
      setDataKey(null);
      setAuthUser(null);
      navigate(pathname);
      isValid = null;
    }
  }, [dataKey, contracts]);

  const login = (emailAddress, password) => {
    doAuthenticate(emailAddress, password);
  }
  
  const logout = async () => {
    setAuthUser(null)
  }

  const doAuthenticate = (emailAddress, password) => {
    const userId = emailAddress;
    const userIdDigest = drizzle.web3.utils.sha3(userId);
    setUserId(userIdDigest);
    const passwordDigest = drizzle.web3.utils.sha3(password);
    
    return checkIdentification(userIdDigest, passwordDigest);
  }

  const checkIdentification = async (userIdDigest, passwordDigest) => {
    var _dataKey = await contract.methods.checkIdentification.cacheCall(userIdDigest, passwordDigest);
    setDataKey(_dataKey);
  }

  return (
    <AuthOperationContext.Provider value={{login, logout}}>
      <AuthUserContext.Provider value={authUser}>
        {children}
      </AuthUserContext.Provider>
    </AuthOperationContext.Provider>
  )
}

export const useAuthUser = () => useContext(AuthUserContext)
export const useLogin = () => useContext(AuthOperationContext).login
export const useLogout = () => useContext(AuthOperationContext).logout

const notifyLoginResult = (loginResult, userId) => {
  return {
    type: LoginActions.LOGIN_TRIED,
    loginResult: loginResult,
    userId: userId
  }
}

const mapStateToProps = state => {
  return {
    contracts: state.contracts
  };
};

export default connect(mapStateToProps)(AuthUserProvider);
